export enum COOKIE {
  SYS_JWT = 'ATE.wd.jtk',
  SYS_CULTURE = 'ATE.wd.lng',
  SYS_SETTINGS = 'ATE.wd.set',
}
// convenzione nome sessione: ATE. + (s.) =session generic + (t.)= opzionale sessione filtro tabella + (3chr) = nome tabella o zona + (2chr)= abbreviazione funzione
export enum SESSION {
  NUMBER = 'ATE.diin.num',
  SEARCH = 'ATE.diin.src',
  SEARCH_BY_ROUTE = 'ATE.diin.srcr',
  DISATTIVO_SWITCH = 'ATE.diin.dis',
  SIDEBAR_COLLAPSED = 'ATE.diin.side',
  HOME_TICKETS_COLLAPSE = 'ATE.diin.web.home.tik',
  CHK_NAV_DATES = 'ATE.diin.chk.nav.dates',
  CHK_WIZARD = 'ATE.diin.chk.wiz',

  PREFIX_NAV_SELECT = 'ATE.diin.sel.',
  // filtri search con component name
  PREFIX_SEARCH_BOX = 'ATE.diin.src.',
  // filtri tabella con component name
  PREFIX_FILTER_TABLE = 'ATE.diin.ftb.',
  // filtri date ranges con component name
  PREFIX_DATES_RANGE = 'ATE.diin.dtr.',
  // generici per altro
  PREFIX_SESSION = 'ATE.diin.ws.',
}

export enum SESSION_TABLEFILTER {
  CHK_PROCEDURE = 'ATE.diin.tf.chk.prc',
  CHK_PROC_DATI = 'ATE.diin.tf.chk.prd',
  DBS_MACCOMPO = 'ATE.diin.tf.dbs.maccom',
  DBS_MACCHINE = 'ATE.diin.tf.dbs.mac',
  TIK_TICKETS = 'ATE.diin.tf.tik.tic',
  MAG_ARTICOLI = 'ATE.diin.tf.mag.art',
}
export enum COOKIE_TABLEFILTER {
  ARTICOLI = 'ATE.diin.tabftl.art',
}
